import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { EXPAND_MORE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ExpandMoreRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={EXPAND_MORE_ROUNDED_GLYPH} />;
